export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/index.js
// module id = 309
// module chunks = 4